import React from 'react';
import { SvgIconProps, SvgIcon } from '@mui/material';

const Replacement = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.52284 9.84136H16.4748L12.6046 5.97117M16.4748 13.1587H6.52284L10.393 17.0289M19.7921 1.5481H3.20553C2.76563 1.5481 2.34374 1.72285 2.03268 2.0339C1.72163 2.34496 1.54688 2.76685 1.54688 3.20675V19.7933C1.54688 20.2332 1.72163 20.6551 2.03268 20.9661C2.34374 21.2772 2.76563 21.4519 3.20553 21.4519H19.7921C20.232 21.4519 20.6539 21.2772 20.9649 20.9661C21.276 20.6551 21.4507 20.2332 21.4507 19.7933V3.20675C21.4507 2.76685 21.276 2.34496 20.9649 2.0339C20.6539 1.72285 20.232 1.5481 19.7921 1.5481Z"
          stroke="var(--mui-palette-text-secondary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Replacement;
